import { Props, Select } from 'chakra-react-select';
import { useTranslations } from 'use-intl';

import { AllowedHoldingMethodOption, AllowedHoldingMethodOptionGroup } from './types';

type HoldingMethodTypeMessage = keyof Messages['HoldingMethodTypeValue'];

type AllowedHoldingMethodSelect = Props<
  AllowedHoldingMethodOption,
  true,
  AllowedHoldingMethodOptionGroup
>;

export function AllowedHoldingMethodSelect({
  defaultValue,
  ...props
}: AllowedHoldingMethodSelect): JSX.Element {
  const i18nHoldingMethodTypeValue = useTranslations('HoldingMethodTypeValue');
  const i18nAllowedHoldingMethodSelect = useTranslations('AllowedHoldingMethodSelect');

  return (
    <Select<AllowedHoldingMethodOption, true>
      isMulti
      closeMenuOnSelect={false}
      colorScheme="indigo"
      defaultValue={defaultValue}
      isClearable={false}
      noOptionsMessage={(): null => null}
      placeholder={i18nAllowedHoldingMethodSelect('PlaceHolder')}
      formatOptionLabel={(holdingMethod): string =>
        i18nHoldingMethodTypeValue(holdingMethod.label as HoldingMethodTypeMessage)
      }
      {...props}
    />
  );
}
